import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { useMergeRefs } from 'rooks';
import { useControllableState } from '../../../hooks/useControllableState';
import { TextInput } from '../TextInput/TextInput';
import { extractValidZipCodeAndCalculateCursorPosition } from './helpers/extractValidZipCodeAndCalculateCursorPosition';
export const ZipCodeInput = forwardRef(({ setValue: setValuePassed, value: valuePassed, defaultValue: defaultValuePassed, onBlur, ...props }, ref) => {
    const [value, setValue] = useControllableState({
        setValue: setValuePassed,
        value: valuePassed,
        defaultValue: defaultValuePassed,
    });
    const inputRef = useRef(null);
    const mergedRefs = useMergeRefs(inputRef, ref);
    const handleChange = (e) => {
        const cursorPosition = e.target.selectionStart;
        const changedValue = e.target.value ?? '';
        const { validZipCode, newCursorPosition } = extractValidZipCodeAndCalculateCursorPosition(changedValue, cursorPosition);
        setValue(validZipCode);
        // Add it to the event queue
        setTimeout(() => {
            if (inputRef.current && newCursorPosition !== null) {
                inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
            }
        }, 0);
    };
    const handleBlur = (e) => {
        if (value) {
            setValue(value.trim());
        }
        onBlur?.(e);
    };
    return (_jsx(TextInput, { ref: mergedRefs, value: value, onChange: handleChange, onBlur: handleBlur, ...props }));
});
